<template>
	<vs-prompt
		:active.sync="activePrompt"
		:buttons-hidden="true"
		:title="$t('confirmAction')"
		button-accept="false"
		button-cancel="filled"
		:cancel-text="$t('refuse')"
		color="warning"
	>
		<div class="con-exemple-prompt">
			{{ $t('checkFullPaymentStage') }} <b>{{ priceClient }}</b> ?
			<div class="flex justify-end mt-8">
				<vs-button
					@click="accept"
					color="warning"
				>{{ $t('confirmPayment') }}</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ConfirmPaymentModal",
	props: {
		active: {
			required: true,
			type: Boolean
		},
		priceClient: {
			required: true,
			type: Number
		}
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		accept() {
			this.activePrompt = false;
			this.$emit("accept");
		}
	}
};
</script>
